import React from 'react';
import PropTypes from 'prop-types';

import LoadingDialog from '../../../components/loadingdialog/components/loadingdialog';
import useContractManagementPage from '../../../modules/hooks/contractmanagementpage/hook';
import ManagementSection from './managementsection';
import AffectedEncountersDialog from './affectedencountersdialog';

const ContractManagement = props => {
  const [state, boundActions] = useContractManagementPage(props.service);

  const {
    affectedEncountersDialog,
    management: {
      contractSettingsData,
      priorityWorkByState,
      priorityStrategyState
    }
  } = state;

  let isACA = false;

  if (contractSettingsData) {
    isACA = (contractSettingsData.selectedContract.lineOfBusiness === 'ACA')
  }

  return (
    <div style={{ overflowY: 'auto', height:'95%' }}>
      {/* title */}
      <div>
        <h3>Contract Management</h3>
      </div>

      {/* contract dropdown */}
      <div>
        <select
          value={state.contractDropdown.selectedItem}
          onChange={boundActions.selectContract}
        >
          <option value="-1">Choose a Contract</option>
          {
            state.contractDropdown.items.map(x => (
              <option
                key={x.value}
                value={x.value}
              >
                {x.label}
              </option>
            ))
          }
        </select>
      </div>

      {/* management section that shows up after selecting contract */}
      <div>
        {/* // TODO THIS CONDITIONAL NULL RENDER MAY BE BAD */}
        {
          contractSettingsData === null
          ? (<span>Please choose a contract from the dropdown</span>)
          : (<ManagementSection
              boundActions={boundActions}
              contractSettingsData={contractSettingsData}
              priorityStrategyState={priorityStrategyState}
              priorityWorkByState={priorityWorkByState}
              isACA={isACA}
            />)
        }
      </div>

      <LoadingDialog
        isOpen={state.isLoading}
        loadingMessage={state.loadingMessage}
      />

      <AffectedEncountersDialog
        {...affectedEncountersDialog}
        removeAuditReasons={boundActions.removeAuditReasons}
        closeDialog={boundActions.closeAffectedEncountersDialog}
      />
    </div>
  );
};

ContractManagement.propTypes = {
  service: PropTypes.object.isRequired
};

export default ContractManagement;
